export const NS_BASE = "trumpf.ux.iws.statefulContent";
export const NS_CONTENT_DATA_PROVIDER = NS_BASE + ".dataProvider";
export const NS_FILTER_PROVIDER = NS_BASE + ".filterProvider";
